import { useEffect, useState } from "react";
import { Timer } from "lucide-react";
import { longCountdown, remainingParts, shortCountdown } from "./survivalClock";

const pad = (n) => String(n).padStart(2, "0");

/** Compact nav timer or large Meet Sam timer. Same remaining-seconds clock. */
export const SurvivalCountdown = ({ variant = "compact", className = "" }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const parts = remainingParts(now);

  if (variant === "story") {
    return (
      <div
        data-testid="story-countdown"
        data-remaining-seconds={parts.totalSeconds}
        className={`flex w-full flex-wrap items-center justify-between gap-2 border border-[#1c2740] bg-[#0b1120]/80 px-3 py-2 ${className}`}
      >
        <span className="mono text-[10px] tracking-[0.25em] text-slate-500">
          FOOD REMAINING / TIME TO UNRECOVERABLE
        </span>
        <div className="flex items-baseline gap-2 font-bold tracking-tight text-white">
          <span className="text-2xl sm:text-3xl">{parts.days}</span>
          <span className="text-sm text-gmh-orange">d</span>
          <span className="mono text-lg tracking-[0.15em] text-gmh-cyan sm:text-xl">
            {pad(parts.hours)}:{pad(parts.minutes)}:{pad(parts.seconds)}
          </span>
        </div>
        <p className="sr-only">{longCountdown(now)}</p>
      </div>
    );
  }

  return (
    <span
      data-testid="survival-countdown"
      data-remaining-seconds={parts.totalSeconds}
      className={`flex items-center gap-1.5 text-slate-400 ${className}`}
    >
      <Timer size={14} className="blink text-gmh-cyan" />
      <span data-testid="countdown-label">
        {shortCountdown(now)}
      </span>
    </span>
  );
};
